"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["MatchInvitedToPlay"] = "match_invited_to_play";
    NotificationType["MatchInvitationAccepted"] = "match_invitation_accepted";
    NotificationType["MatchInvitationDeclined"] = "match_invitation_declined";
    NotificationType["MatchJoinRequest"] = "match_join_request";
    NotificationType["MatchJoined"] = "match_joined";
    NotificationType["MatchJoinRequestAccepted"] = "match_join_request_accepted";
    NotificationType["MatchJoinRequestDeclined"] = "match_join_request_declined";
    NotificationType["MatchDeclined"] = "match_declined";
    NotificationType["MatchFinishedAborted"] = "match_finished_aborted";
    NotificationType["MatchFinishedInTie"] = "match_finished_in_tie";
    NotificationType["MatchFinishedWon"] = "match_finished_won";
    NotificationType["MatchFinished"] = "match_finished";
    NotificationType["TournamentCanceled"] = "tournament_canceled";
    NotificationType["TournamentStarted"] = "tournament_started";
    NotificationType["TournamentAdminAdded"] = "tournament_admin_added";
    NotificationType["TournamentFinished"] = "tournament_finished";
    NotificationType["TournamentInvitedToPlay"] = "tournament_invited_to_play";
    NotificationType["TournamentJoinRequestDeclined"] = "tournament_join_request_declined";
    NotificationType["TournamentJoinRequestAccepted"] = "tournament_join_request_accepted";
    NotificationType["TournamentPlayerWithdrawn"] = "tournament_player_withdraw";
    NotificationType["TournamentCaptainWithdrawn"] = "tournament_captain_withdraw";
    NotificationType["TournamentPlayerDeleted"] = "tournament_player_deleted";
    NotificationType["TournamentCheckinStarted"] = "tournament_checkin_started";
    NotificationType["TournamentMatchStarted"] = "tournament_match_started";
    NotificationType["TournamentRescheduled"] = "tournament_rescheduled";
    NotificationType["TournamentMatchFinished"] = "tournament_match_finished";
    NotificationType["TournamentTeamDisqualified"] = "tournament_team_disqualified";
    NotificationType["TournamentNewRoundCheckin"] = "tournament_new_round_checkin";
    NotificationType["TournamentMatchGameExpired"] = "tournament_match_game_expired";
    NotificationType["TournamentAnnouncement"] = "tournament_announcement";
    NotificationType["TournamentSpectatorInvited"] = "tournament_spectator_invited";
    NotificationType["TournamentSpectatorJoinRequestAccepted"] = "tournament_spectator_join_request_accepted";
    NotificationType["TournamentSpectatorJoinRequestDeclined"] = "tournament_spectator_join_request_declined";
    NotificationType["BalanceAutoSwapSuccessful"] = "balance_auto_swap_successful";
    NotificationType["BalanceAutoSwapFailed"] = "balance_auto_swap_failed";
    NotificationType["BalancePaypalWithdrawalRequestCreated"] = "balance_paypal_withdrawal_request_created";
    NotificationType["BalancePaypalWithdrawalRequestCompleted"] = "balance_paypal_withdrawal_request_completed";
    NotificationType["BalancePaypalWithdrawalRequestRejected"] = "balance_payment.paypal_withdrawal_request_rejected";
    NotificationType["AffiliateProgramCommissionPayoutComplete"] = "affiliate_program.commission_payout_complete";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=notification-type.js.map